<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="title" :class="msg_type"></div>
                    <div class="msg-view" :class="msg_type">
                        <p>{{ text }}</p>
                    </div>

                    <div class="u-btn charge" v-if="type !=1 && ($store.state.userinfo.fromType == 0)"><a href="https://pay.17m3.com/" target="_blank" rel="noopener noreferrer"></a></div>
                    <div class="u-btn ok" v-else @click="closeModal"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.msg-modal{
    width: 667px;
    height: 378px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
    padding: 80px 0 20px;
    color: #cbbda5;
    text-align: center;

    b{
        font-size: 28px;
    }

    em{
        color: #e44130;
    }    
}

.u-ctrl{
    // position: absolute;
    // width: 100%;
    // left: 50%;
    // bottom: 34px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // transform: translateX(-50%);
    // box-sizing: border-box;
    // padding: 0 110px;
}

.u-btn.charge{
    width: 230px;
    height: 76px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/modal/btn-pay.png);
    
    a{
        display: block;
        width: 100%;
        height: 100%;
    }
}

.u-btn.ok{
    width: 230px;
    height: 76px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/modal/btn-ok.png);
    
    a{
        display: block;
        width: 100%;
        height: 100%;
    }
}

</style>

<style>
.msg-view em{
    color: #e44130;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 1,
            name : '',
            msg_type : 'message'
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条 
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },                  
    },    
}
</script>